import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import PergolasPage from './pages/PergolasPage';
import AwningsPage from './pages/AwningsPage';
import PergolaQuotePage from './pages/PergolaQuotePage';
import { AwningQuotePage } from './pages/AwningQuotePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pergolas" element={<PergolasPage />} />
          <Route path="/awnings" element={<AwningsPage />} />
          <Route path="/pergola-quote" element={<PergolaQuotePage />} />
          <Route path="/awning-quote" element={<AwningQuotePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
